const routes = [
  {
    path: '/kepu-carnival',
    name: 'kepu-carnival',
    component: () => import('@/views/kepu-carnival/kepuCarnival.vue'),
    meta: {
      title: '科普嘉年华',
      keepAlive: true,
    },
  },
  {
    path: '/kepu-carnival/games',
    name: 'kepu-carnival-games',
    component: () => import('@/views/kepu-carnival/GameList.vue'),
    meta: {
      title: '更多游戏',
    },
  },
  {
    path: '/kepu-carnival/question',
    name: 'kepu-carnival-question',
    component: () => import('@/views/kepu-carnival/QuestionDetail.vue'),
    meta: {
      title: '每日积分问答',
    },
  },
];
export default routes;
